// typings

import { create } from "zustand";

import { ITiposEntregaState } from "@/store-zustand/tipos-entrega/index.d";

// criação da store com Zustand (tipos de entrgas)
export const useStoreZustandTiposEntregas = create<ITiposEntregaState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  tipoEntregaId: null,
  tiposEntregas: [],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setTipoEntregaId: (tipoEntregaId) => set({ tipoEntregaId }),
  setTiposEntregas: (tiposEntregas) => set({ tiposEntregas }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
}));
